import { useState } from 'react';
import { downloadFileFromTrpc } from 'further-ui/utils';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api, { ApiInputs, ApiResponses } from 'lib/trpcClient';

const usePeriodEndReportPdf = () => {
  const [inFlightInvestorPdfDownloads, setInFlightInvestorPdfDownloads] =
    useState<Set<string>>(new Set());

  const { mutate: downloadPdf } = api.periodEndReport.downloadPdf.useMutation(
    useHandleTrpcMutation<
      ApiResponses['periodEndReport']['downloadPdf'],
      ApiInputs['periodEndReport']['downloadPdf']
    >()({
      invalidations: [],
      onMutate: ({ investorId, periodEndReportId }) => {
        setInFlightInvestorPdfDownloads((prev) => {
          const newSet = new Set(prev);
          newSet.add(`${periodEndReportId}-${investorId}`);
          return newSet;
        });
      },
      onSuccess: ({ file, filename, mimeType }) => {
        downloadFileFromTrpc({
          content: file,
          name: filename,
          mimeType,
        });
      },
      onSettled: (_, __, input) => {
        setInFlightInvestorPdfDownloads((prev) => {
          const newSet = new Set(prev);
          newSet.delete(`${input.periodEndReportId}-${input.investorId}`);
          return newSet;
        });
      },
    }),
  );

  const isDownloading = (periodEndReportId: string, investorId: string) => {
    return inFlightInvestorPdfDownloads.has(
      `${periodEndReportId}-${investorId}`,
    );
  };

  return {
    downloadPdf,
    isDownloading,
  };
};

export default usePeriodEndReportPdf;
